import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Badge from '../../../Badge/Badge'

export const HasIssueItem = ({ hasIssue }) => {
  const { t } = useTranslation(['internal-inspections'])
  return (
    <div className="has-issue-item">
      <span className="details-label">{t('internal-inspections:locationItem.issue')}</span>
      {hasIssue ? (
        <Badge color="red">{t('internal-inspections:locationItem.yes')}</Badge>
      ) : (
        <Badge color="green">{t('internal-inspections:locationItem.no')}</Badge>
      )}
    </div>
  )
}

HasIssueItem.propTypes = {
  hasIssue: PropTypes.bool,
}

export default HasIssueItem
